<template>
  <div class="row">
      <div class="col-md-6">
        <PrimaryInput
          v-model="user.name"
          :required="true"
          placeholder="Nome (fica no certificado)"
        />
      </div>

      <div class="col-md-6">
        <PrimaryInput
          v-model="user.email"
          :required="true"
          placeholder="Email"
          type="email"
        />
      </div>

      <div class="col-md-6">
        <PrimaryInput
          v-model="user.password"
          type="password"
          placeholder="Nova senha"
          autocomplete="off"
        />
      </div>

      <div class="col-md-6">
        <PrimaryInput
          v-model="user.password_confirmation"
          type="password"
          placeholder="Confirme a nova senha"
          autocomplete="off"
        />
      </div>

      <div class="col-12">
        <PrimaryInput
          v-model="user.bio"
          type="textarea"
          placeholder="Bio"
          autocomplete="off"
          rows="4"
          maxlength="1000"
          class="mb-0"
        />
      </div>
    </div>
</template>

<script>
import PrimaryInput from '@/components/form/PrimaryInput'

export default {
  components: {
    PrimaryInput,
  },

  props: {
    user: { type: Object, required: true }
  }
}
</script>